export default "__VITE_ASSET__B8O2YkGe__"